export interface RouteSnapshotLike {
  routeConfig: { path?: string } | null;
  firstChild: RouteSnapshotLike | null;
}

export function buildRoutePattern(root: RouteSnapshotLike): string {
  const segments: string[] = [];
  let node: RouteSnapshotLike | null = root;
  while (node) {
    const path = node.routeConfig?.path;
    if (path) segments.push(path);
    node = node.firstChild;
  }
  return '/' + segments.join('/');
}

export function productArea(pattern: string): string {
  return pattern.split('/').filter(Boolean)[0] ?? 'root';
}
